/** Base mainnet TopCo (preprod + prod; same chain 8453). Override via NEXT_PUBLIC_* if needed. */
const BASE_MAINNET_OWNERSHIP_NFT = '0xa1c84e140eBE718bf6fE01bD5B13E9BBc9AC4568' as const
const BASE_MAINNET_OWNERSHIP_STAKING =
  '0xFD8e8DEf1dE73Dd153dA51C864b20E05e6be6552' as const

/** Latest Base Sepolia TopCo deploy. Used as fallback for `dev` and `stage` on 84532. Override via NEXT_PUBLIC_* if needed. */
const BASE_SEPOLIA_DEV_OWNERSHIP_NFT =
  '0x7479a7DBeCbfBB6Faa5dBB28ceAc03CE5685242C' as const
const BASE_SEPOLIA_DEV_OWNERSHIP_STAKING =
  '0xd433eFFC92C18b76c5121a975B3a83eeCcfd519b' as const

/** Base mainnet: WhitelistedVesting and StrategicPartners2 share one emergency deployment. */
const BASE_MAINNET_SHARED_VESTING_CONTRACT =
  '0x7Fd2f60b159920d7Dd4544150CE140890052000d' as const

export const contractAddresses = {
  // Mainnet
  '1': {
    GenesisNFTV1: '0x22318dc6DB1BA94A7A1b32437E7867cC415286a1',
    GenesisNFTV2: '0xAE2DfbDDEF17998a638b26B38AAfD7e4625cA41A',
    GenesisNFTV1Legacy: '0x2b5469931fc530aba7bf30e6f8118a9d6e37143e',
    StakingGenesisNFT: '0xAB14624691d0D1b62F9797368104Ef1F8C20dF83',
  },
  // Base mainnet
  '8453': {
    get production() {
      return {
        USDC: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
        InvestmentFundRegistry: '0xA9bc2bC53BA0D85FC212b28C662Ba853387e1CA1',
        GenesisNFTV1: '0x51dA71fCFe737115754aCFBa9A20d4C98aB9c900',
        GenesisNFTV2: '0x9Ba8d198B0450Ee50A1f55d6eD7E904e171A0408',
        Wlth: '0x99b2B1A2aDB02B38222ADcD057783D7e5D1FCC7D',
        StakingGenesisNFTVesting: '0x87412C03979Cc19C60071F5F98313a7cBE9F6d65',
        UniswapWlthPriceOracle: '0xfa33c7e21b88F6DBe524392e92a1229C6C7fe6aD',
        StakingForDiscount: '0x5E71a0c7022D02639dFfAA386a0044c51b3B339b',
        GenesisNFTVesting: '0xB8c2C8B72c45ca59FC0aFb11B5696694695f45EF',
        WlthBonusStaking: '0xD7E31990883250E53314b15EE555345f04D011E8',
        WhitelistedVesting:
          process.env.NEXT_PUBLIC_WHITELISTED_VESTING_ADDRESS ??
          BASE_MAINNET_SHARED_VESTING_CONTRACT,
        StrategicPartners2:
          process.env.NEXT_PUBLIC_STRATEGIC_PARTNERS2_VESTING_ADDRESS ??
          BASE_MAINNET_SHARED_VESTING_CONTRACT,
        Marketing: '0xcA8310e5fC441f9c7e575C64a8d992F455e6b7BF',
        Marketplace: '0x9AAdDBb115fd99c28bB70a30EDbEbEDedCa0fb65',
        Advisors: '0x34D6aaba93AfEE10fAC35818f9d40FD0F393848E',
        ParticipationStaking: '0xF4AA59f5192856F41Ae19CaAb4929CCD3a265e70',
        StrategicPartners1: '0x7f44155a0E58384dF4919797Cd5689FeeD667F91',
        Team: '0xA02A79793227c368772D934681d84C099c5B8497',
        GiftingBundle: '0x381204789928Fc3a5543c23B4c4a3D14b403bC30',
        MinimalForwarder: '0xc91dD1cBA6D86E8b6BDE86d78A92e84CBC9a7A25',
        TokenTransferGateway: '0x004b6f7DF6c114521eB3Cd503B7b9D6bAE7E5d3F',
        OwnershipNFT:
          process.env.NEXT_PUBLIC_OWNERSHIP_NFT_ADDRESS || BASE_MAINNET_OWNERSHIP_NFT,
        OwnershipStaking:
          process.env.NEXT_PUBLIC_OWNERSHIP_STAKING_ADDRESS ||
          BASE_MAINNET_OWNERSHIP_STAKING,
      }
    },
  },
  // Base Sepolia Testnet
  '84532': {
    stage: {
      GenesisNFTV1: '0x5cC42399D194Bcd9B3eE589ed87623f7A2b4CecC',
      GenesisNFTV2: '0x3bb621C1F70a8706b9eE3dBc5E885543Ee92daD7',
      USDC: '0x35cc008B4E54bFa4859cc1D6898a9B336091A4c2',
      Wlth: '0xfda863bB2cE32467081736Ce57BA93df5017204e',
      InvestmentFundRegistry: '0xe006ab3eb0c6B2F4eC4A35572D2f9F5F2e03E5CB',
      UniswapWlthPriceOracle: '0x27Fa2c35f616e1a8932a098CA9627856b9Ab3f2E',
      UniswapSwapper: '0x0000000000000000000000000000000000000000',
      StakingForDiscount: '0xAB6685A58974915a22565Ac4cB349ec27713d5b2',
      StakingGenesisNFTVesting: '0x637A409F2113416363a7fAcF705D79c5fdeAf510',
      GenesisNFTVesting: '0x5A12da98ABDcAA90a36E80Dc90eAf68a19D9a30e',
      WlthBonusStaking: '0xc60CcA6F912AAe682F0a4FE3C395Aa487172C080',
      WhitelistedVesting: '0xBAa64766196035Fff517B0a7c457a67f3747f8Da',
      StrategicPartners2: '0xbd0421144d1850A82bf56Cb21fE24f4B1E1992a7',
      Marketing: '0xDa16A9fc670E9749DBb8F54D3bf95784A719F691',
      Advisors: '0x7Fd6D78c0185769415b45048f02150472b10428e',
      Marketplace: '0x56FDc8A940139D0d5d5Fd22C3805539fb26fad28',
      ParticipationStaking: '0x0892879c445D543FF4639003ba61aE83E717D3bB',
      StrategicPartners1: '0x5f875F64E2945064c57c37bF8d71498DfB05f1E6',
      Team: '0xe03bE4fcC74C5037D8BA115F7a93453ac375ee2F',
      GiftingBundle: '0x37F48E9171EA79762E3DB9916bFcfF966132ebdf',
      OwnershipNFT:
        process.env.NEXT_PUBLIC_OWNERSHIP_NFT_ADDRESS || BASE_SEPOLIA_DEV_OWNERSHIP_NFT,
      OwnershipStaking:
        process.env.NEXT_PUBLIC_OWNERSHIP_STAKING_ADDRESS ||
        BASE_SEPOLIA_DEV_OWNERSHIP_STAKING,
    },
    dev: {
      GenesisNFTV1: '0xCB0Ef07D6cFFEc9490c15E39a0a029B0B9F84587',
      GenesisNFTV2: '0xFF20595Ed2e2281E07f07CDe40898D695410eFFE',
      USDC: '0xEE0C8949DF67f0BBa3E34028F9e600b14d7bfcAf',
      Wlth: '0x46AEfB9Acb32d05C99c80d443286FB6033744dea',
      InvestmentFundRegistry: '0x1D5a26173Bf90d64f4c83a6641F13124BBeDf881',
      UniswapWlthPriceOracle: '0xb1bACaFDa81212E52c5e9d0E116Ae88dB5d685f8',
      UniswapSwapper: '0xD0Db79FC44a5D746D4Fc63BD19c8CF1d462Afe95',
      StakingForDiscount: '0x485d57a422BF6158407D360d46c30e4A4Caa8849',
      StakingGenesisNFTVesting: '0xf2709E94Eaf73e200952338aC9398a1C8362a23F',
      GenesisNFTVesting: '0xC416b8d0873E99c68F8179bc71543b58913FA44d',
      WlthBonusStaking: '0xF9C2Cd579FEDa77b1D046E3977A8335CA7368Be2',
      WhitelistedVesting: '0x9D1fdEB82f4c53355959787188F4a3498eEF0851',
      StrategicPartners2: '0x1bA392a190D75F765E183BD25268760c3dF57f4E',
      Marketing: '0xF754b01AE9FE8Ce9014270e323d554F0Fed86fbF',
      Marketplace: '0xd7e79f4D270F40117E1287e2fBa7D4D9D7F006D4',
      Advisors: '0xBEBb72b2fF037fe78e8B9542752a182Fc22C1518',
      ParticipationStaking: '0x25944Cd77F36507789Cb0381F7c9B5Da6F96C108',
      StrategicPartners1: '0x93aa6d067c321b1B59620F847eBC46a71443f1d7',
      Team: '0xe7f8bE412500EbBd35177C2F8948342762B521DC',
      GiftingBundle: '0x0eD31dF8b2DBc30bF91Ef327a86587788fECf99e',
      MinimalForwarder: '0xe161824E587e3C52dccC3b3fAD199f058e4a2f64',
      TokenTransferGateway: '0x4f032eC96689496907B49e2DD1b3cf4d4f880120',
      OwnershipNFT:
        process.env.NEXT_PUBLIC_OWNERSHIP_NFT_ADDRESS || BASE_SEPOLIA_DEV_OWNERSHIP_NFT,
      OwnershipStaking:
        process.env.NEXT_PUBLIC_OWNERSHIP_STAKING_ADDRESS ||
        BASE_SEPOLIA_DEV_OWNERSHIP_STAKING,
    },
  },
}
